import { render, staticRenderFns } from "./BubbleMap.vue?vue&type=template&id=ddaf8850&"
import script from "./BubbleMap.vue?vue&type=script&lang=js&"
export * from "./BubbleMap.vue?vue&type=script&lang=js&"
import style0 from "./BubbleMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports